import React, { useEffect, useContext } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider, useDispatch, useSelector } from 'react-redux';
import store from './store';
import AppRoutes from './routes';
import './styles/global.css';

import { ProfileProvider, ProfileContext } from './contexts/ProfileContext';
import { fetchTheme } from './store/themeSlice';
import ThemeApplier from './components/theme/ThemeApplier';

// Component to fetch theme when app starts
const AppInitializer = () => {
  const dispatch = useDispatch();
  const theme = useSelector(state => state.theme.values);

  useEffect(() => {
    console.log("Initial Theme in Redux:", theme);
    dispatch(fetchTheme()); // Fetch theme from the mock API
  }, [dispatch]);

  useEffect(() => {
    console.log("Updated Theme in Redux:", theme); 
  }, [theme]); 


  return null; 
};

const RenderRoutes = () => {
  const { tenantKey } = useContext(ProfileContext);
  return <AppRoutes key={tenantKey} />;
};

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <ProfileProvider>
          <AppInitializer />
          <ThemeApplier />
          {/* <AppRoutes /> */}
          <RenderRoutes />
        </ProfileProvider>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
